import { Events, handleAnalytics } from '@foxcorp/delta-web-analytics';
import {
  createFavorite,
  deleteFavoritesForAccount,
  getFavoritesDetailsForAccount,
  filterByFavoriteType,
  FAVORITE_DOMAINS,
  setInitialFavoritesStorage,
} from 'helpers/AccountHelper';
import { getCurrentAccount } from 'helpers/AnonymousHelper';
import { PAGE_TYPE_WATCHLIST } from 'helpers/ContentHelper';

export async function getFavorites() {
  const { profileFavorites } = this.props;
  const fetchFavorites = async () => profileFavorites.get({ domains: FAVORITE_DOMAINS });

  try {
    const { favorites } = await fetchFavorites();
    const filteredFavorites = filterByFavoriteType(favorites);
    setInitialFavoritesStorage(filteredFavorites);
    this.getFavoritesDetails(filteredFavorites);
  } catch (error) {
    console.error('Error fetching favorites:', error);
  }
}

export async function getFavoritesDetails(initialFavorites) {
  const { isLoadingFavorites } = this.state;
  const { account, anonymousAccount } = this.props;
  const currentAccount = account || anonymousAccount;

  if (!currentAccount || isLoadingFavorites) return;

  this.setState({ isLoadingFavorites: true });
  let favorites = initialFavorites;
  if (!favorites?.length > 1) favorites = [];
  const { items } = await getFavoritesDetailsForAccount(currentAccount, favorites);
  this.setAppFavorites({ favorites, favoritesDetails: items, isLoadingFavorites: false });
}

const formatFavorite = favoritableItems =>
  favoritableItems.map(item => {
    const { id, '@type': type } = item;
    return { id, type };
  });

export async function setFavorites(favorite) {
  const {
    favorites: [...favorites],
  } = this.state;
  const { account, anonymousAccount, deviceId, profileFavorites } = this.props;
  const pathName = window?.location?.pathname?.split('/')?.[1];

  handleAnalytics({
    event: Events.BUTTON_LINK_SELECTED,
    payload: {
      page_button_text: PAGE_TYPE_WATCHLIST,
      page_collection_title: favorite?.seriesName?.toLowerCase(),
      page_name: 'delta:web',
      page_type: pathName,
    },
  });
  return new Promise(async resolve => {
    const currentAccount = await getCurrentAccount({
      account,
      anonymousAccount,
      anonymousLogin: this.anonymousLogin,
      deviceId,
    });
    const result = await createFavorite(currentAccount, favorite, profileFavorites);
    const { favoritableItems } = favorite;
    const formattedFavorites = formatFavorite(favoritableItems);

    if (favorites) favorites.push(...formattedFavorites);
    const newFavorites = favorites || formattedFavorites;
    this.setAppFavorites({ favorites: newFavorites });
    resolve(result);
  });
}

export async function deleteFavorites({ favoriteList, favoritesDetails }) {
  const { favorites } = this.state;
  const { account, anonymousAccount, deviceId, profileFavorites } = this.props;

  return new Promise(async resolve => {
    const currentAccount = await getCurrentAccount({
      account,
      anonymousAccount,
      anonymousLogin: this.anonymousLogin,
      deviceId,
    });
    const result = await deleteFavoritesForAccount(currentAccount, favoriteList, profileFavorites);
    const newFavorites = [];
    const newFavoritesDetails = [];
    favorites.forEach(item => {
      const isMatched = !!favoriteList.filter(fav => fav.showID === item.id).length;
      if (!isMatched) newFavorites.push(item);
    });

    favoritesDetails.forEach(item => {
      const isDetailsMatched = !!favoriteList.filter(fav => fav.showID === item.showCode).length;
      if (!isDetailsMatched) newFavoritesDetails.push(item);
    });

    this.setAppFavorites({
      favorites: newFavorites,
      favoritesDetails: newFavoritesDetails,
      isLoadingFavorites: false,
    });

    resolve(result);
  });
}

export function setAppFavorites({ favorites, favoritesDetails, isLoadingFavorites }) {
  const newState = {};

  if (favorites !== undefined && favorites !== this.state.favorites) {
    newState.favorites = favorites;
  }

  if (favoritesDetails !== undefined && favoritesDetails !== this.state.favoritesDetails) {
    newState.favoritesDetails = favoritesDetails;
  }

  newState.isLoadingFavorites = isLoadingFavorites;

  if (newState.favorites || newState.favoritesDetails || newState.isLoadingFavorites) {
    this.setState(newState);
  }
}
